import EventEmitter from 'eventemitter3'

// Common Events for use by all Apps
export enum AppEvents {
		AppSave = "App.Save",
		AppQuit = "App.Quit"
}

const AppEmitter_ = new EventEmitter();
export default AppEmitter_;